import Vue from 'vue';

export default Vue.component('ed-form', {
  name: 'ed-form',
  inheritAttrs: false,
  watch: {
    $attrs: {
      deep: true,
      handler() {
        let form = this.$attrs.value;
        let fields = [];
        if(form.fieldsName) {
          form.fieldsName.forEach(k => {
            fields.push(form[k].valid);
          });
        }
        this.$attrs.value.valid = fields.length > 0 ? fields.reduce(
          (acc, valid) => {
            return acc && valid 
          }) : true;
        
        this.$emit('input', this.$attrs.value);
      }
    }
  }
});
